import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  showIcon?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  size = 'lg',
  showIcon = true,
  className = '',
  ...props
}: ButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-bold',
    xl: 'px-10 py-5 text-xl font-bold uppercase tracking-wide'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden group
        bg-gradient-to-r from-amber-600 to-amber-500 
        hover:from-amber-500 hover:to-amber-400
        text-zinc-950 rounded-lg shadow-[0_0_20px_rgba(245,158,11,0.3)]
        hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]
        transition-all duration-300 flex items-center justify-center gap-2
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-270">
      <span className="relative z-10 flex items-center gap-2" data-id="element-271">
        {children}
        {showIcon && <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-272" />}
      </span>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 z-0" data-id="element-273" />
    </motion.button>;
}